import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";

class VideoMessage extends Component {

    render() {
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    <video controls width="250" style={{width:"100%"}}>
                        <source src={this.props.message.message.text}
                            type="video/mp4" />
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                </div>
                {this.showMessageTime() && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.message.message.sentTimestamp/1000)).format("h:mm a")}</div>}
            </div>
        )
    }

    showMessageTime = () => {
        return (this.props.message.type !== MessageType.info);
    }

    messageTimeClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-time-sent";
            case MessageType.received: return "s360-message-time-received";
            default: return "";
        }
    }

    messageBoxClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-box-sent";
            case MessageType.received: return "s360-message-box-received";
            default: return "";
        }
    }

    messageContainerClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-cotainer-sent";
            case MessageType.received: return "s360-message-cotainer-received";
            default: return "";
        }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        switch (this.props.message.type) {
            case MessageType.received: return { height:"105px", background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor }
            case MessageType.sent: return { height:"105px", background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.ReceiverMessageFont, fontSize: config.designDetails.ReceiverMessageFontSize, color: config.designDetails.recieverMessageFontColor }
            default: return {}
        }
    }

    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        switch (this.props.message.type) {
            case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
            case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
            case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
            default: return {}
        }
    }

}

export default VideoMessage;
